import React from "react";
import Header from "../components/Header-2";
import { IKContext, IKImage } from "imagekitio-react";

function Contact() {
  const images = [
    "/portraits/isaiah_U6ide3nPz.webp",
    "/portraits/david_Gsix8W.webp",
    "/portraits/_brianne_6uwT9yJmk_UJOLEmkps.webp",
    "/portraits/Jonathan_8390602582_5HiFtdFon.webp",
    "/portraits/_DSC7495_fkorC_PVC_L9U7tfXMw.webp",
    "/portraits/Tyjay_ok4sGzKi0.webp",
  ];
  const featuredImage = images[0];

  return (
    <div className="h-auto sm:h-screen dark:bg-[#201c1c]">
      {/* <!-- Contact form section --> */}
      <Header />
      <section
        id="#contact"
        className="pb-12 pt-12 lg:h-full flex justify-center mx-auto bg-[#f4f2f2] dark:bg-[#201c1c] text-[#252525] dark:text-zinc-100 sm:rounded-2xl"
      >
        {/* <!-- Grid Container --> */}
        <div className="md:grid lg:grid-cols-2 max-w-5xl mx-auto items-center">
          {/* <!-- Left column --> */}
          <div className="pt-8 mx-auto text-xl max-w-md pb-20">
            <IKContext urlEndpoint="https://ik.imagekit.io/bbwxfzjdl2zg">
              <div className="rounded-lg justify-center align-middle mx-auto overflow-hidden shadow-lg bg-slate-100 dark:bg-[#322c2c]">
                <IKImage
                  path={featuredImage}
                  alt="Featured portrait"
                  className="w-full h-auto object-cover p-3"
                />
              </div>
            </IKContext>
          </div>
          {/* <!-- Right column --> */}
          <div className="md:pl-16 p-5">
            <h2 className="text-4xl pb-8 text-center font-poppinsFont font-extrabold">
              Let's Connect
            </h2>
            <p className="max-w-xl mx-auto mb-8">
              Whether you're looking for portraits, event coverage, interior
              photography, or a creative collaboration, I'd love to hear about
              your project. Tell me a little about what you're planning and I'll
              get back to you soon.
            </p>
            <p className="mb-10">📍 Toronto, Ontario</p>
            <form
              className="w-full max-w-lg mx-auto"
              action="https://formspree.io/f/mbjwplbn"
              method="POST"
            >
              <div className="flex flex-wrap -mx-3 mb-6">
                <div className="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    type="text"
                    placeholder="Name"
                  />
                </div>
                <div className="w-full md:w-1/2 px-3">
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    type="email"
                    name="email"
                    placeholder="Email"
                  />
                </div>
              </div>
              <div className="flex flex-wrap -mx-3 mb-6">
                {/* <div className="w-full px-3">
                  <input
                    className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    type="text"
                    placeholder="Subject"
                  />
                </div> */}
                <div className="w-full px-3">
                  <textarea
                    className="w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                    name="message"
                    rows="12"
                    placeholder="Message"
                  ></textarea>
                </div>
              </div>
              <button
                id="contact"
                type="submit"
                className="bg-[#c37a8e] w-full text-center p-3 rounded-md mx-auto hover:bg-[#a66879] text-white"
              >
                Send Message
              </button>
            </form>
            <p className="pt-4 pb-4 text-xs text-center opacity-50">
              Typically responds within 24–48 hours.
            </p>
            <p className="text-[#a1a0a0]">Instagram</p>
            <p>@capmatic</p>
            <p className="text-[#a1a0a0] pt-5">Email</p>
            <p>contact@isaiahsylvester.com</p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
